import getImageUrl from '@configuratorware/configurator-frontendgui/App/Utils/getImageUrl';
import { useSelector } from 'react-redux';

export default function useGroundPlanUrl() {
  const identifier = useSelector((state) => state.configurator.configuration.item.identifier);
  return identifier ? getImageUrl(`/images/configuratorimages/${identifier}/${identifier}_layout.svg`) : '';
}
